<template>
  <div class="crash-controls">
    <div class="controls-amount">
      <div class="bet-label">Your Bet</div>
      <div class="bet-input-container">
        <div class="bet-icon-wrapper">
          <IconCoin />
        </div>
        <div class="bet-separator"></div>
        <div class="bet-value-display">
          <input
            v-model="crashAmount"
            v-on:input="crashValidateInput"
            v-on:change="crashFormatInput"
            type="text"
            class="bet-value-input"
            placeholder="0.00"
            v-bind:disabled="crashAutoRunning === true"
          />
        </div>
        <div class="bet-quick-actions">
          <button
            v-on:click="crashSetInput('crashAmount', '1/2')"
            class="quick-action-btn"
            v-bind:disabled="crashAutoRunning === true"
          >
            1/2
          </button>
          <button
            v-on:click="crashSetInput('crashAmount', '2x')"
            class="quick-action-btn"
            v-bind:disabled="crashAutoRunning === true"
          >
            2X
          </button>
          <button
            v-on:click="crashSetInput('crashAmount', 'max')"
            class="quick-action-btn max-btn"
            v-bind:disabled="crashAutoRunning === true"
          >
            MAX
          </button>
        </div>
      </div>
      <div class="bet-preset-buttons">
        <button
          v-on:click="crashSetInput('crashAmount', '10')"
          class="preset-btn"
          v-bind:disabled="crashAutoRunning === true"
        >
          10
        </button>
        <button
          v-on:click="crashSetInput('crashAmount', '100')"
          class="preset-btn"
          v-bind:disabled="crashAutoRunning === true"
        >
          100
        </button>
        <button
          v-on:click="crashSetInput('crashAmount', '1000')"
          class="preset-btn"
          v-bind:disabled="crashAutoRunning === true"
        >
          1.0k
        </button>
        <button
          v-on:click="crashSetInput('crashAmount', '10000')"
          class="preset-btn"
          v-bind:disabled="crashAutoRunning === true"
        >
          10.0k
        </button>
      </div>
    </div>
    <div v-if="crashMode === 'manual'" class="controls-manual">
      <button
        v-if="
          authUser.user !== null &&
          crashGame !== null &&
          crashGame.state !== 'completed' &&
          crashBets.some(
            (element) =>
              element.user._id === authUser.user._id &&
              element.multiplier === undefined
          ) === true
        "
        v-on:click="crashBetCashout"
        class="button-cashout"
        v-bind:disabled="crashGame.state !== 'rolling'"
      >
        <div class="button-inner">
          {{ crashGame.state !== "rolling" ? "STARTING..." : "CASHOUT" }}
        </div>
      </button>
      <button v-else v-on:click="crashBetButton" class="button-bet">
        <div class="button-inner">{{ crashGame && crashGame.state === 'created' ? 'BET (NEXT ROUND)' : 'PLACE BET' }}</div>
      </button>
      <div class="manual-bets">
        <div class="bets-header">
          <div class="header-player">
            <IconUsers />
            PLAYERS
            <span>{{ crashGetPlayerCount }}</span>
          </div>
          <div class="header-amount">
            <IconCoin />
            <div class="amount-value">
              <span>{{
                crashFormatValue(crashGetBetsAmount).split(".")[0]
              }}</span
              >.{{ crashFormatValue(crashGetBetsAmount).split(".")[1] }}
            </div>
          </div>
        </div>
        <div class="bets-content">
          <div class="content-list">
            <CrashBetElement
              v-for="bet of crashBets"
              v-bind:key="bet._id"
              v-bind:bet="bet"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="controls-auto">
      <div class="auto-adjust">
        <div class="adjust-win">
          <input
            v-model="crashAutoPercentageWin"
            type="text"
            placeholder="% ON WIN"
            v-bind:disabled="crashAutoRunning === true"
          />
        </div>
        <div class="adjust-lose">
          <input
            v-model="crashAutoPercentageLoss"
            type="text"
            placeholder="% ON LOSS"
            v-bind:disabled="crashAutoRunning === true"
          />
        </div>
      </div>
      <div class="auto-stop">
        <div class="stop-profit">
          <input
            v-model="crashAutoStopProfit"
            type="text"
            placeholder="STOP ON PROFIT"
            v-bind:disabled="crashAutoRunning === true"
          />
          <IconCoin />
        </div>
        <div class="stop-lose">
          <input
            v-model="crashAutoStopLoss"
            type="text"
            placeholder="STOP ON LOSS"
            v-bind:disabled="crashAutoRunning === true"
          />
          <IconCoin />
        </div>
      </div>
      <div class="auto-count">
        <input
          v-model="crashAutoBetCount"
          type="text"
          placeholder="TOTAL BETS"
        />
      </div>
      <button
        v-if="crashAutoRunning === true"
        v-on:click="crashAutoStopButton"
        class="button-stop"
      >
        <div class="button-inner">Stop auto</div>
      </button>
      <button v-else v-on:click="crashAutoStartButton" class="button-auto">
        <div class="button-inner">Start auto</div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IconUsers from "@/components/icons/IconUsers";
import CrashBetElement from "@/components/crash/CrashBetElement";
import IconCoin from "@/components/icons/IconCoin";

export default {
  name: "CrashControls",
  components: {
    IconUsers,
    CrashBetElement,
    IconCoin,
  },
  data() {
    return {
      crashMode: "manual",
      crashAutoRunning: false,
      crashAutoInfinite: false,
      crashAmount: null,
      crashAutoCashout: null,
      crashAutoPercentageWin: null,
      crashAutoPercentageLoss: null,
      crashAutoStopProfit: null,
      crashAutoStopLoss: null,
      crashAutoBetCount: null,
      crashAutoTotalBet: 0,
      crashAutoTotalWon: 0,
    };
  },
  methods: {
    ...mapActions([
      "notificationShow",
      "crashSendBetSocket",
      "crashSendCashoutSocket",
    ]),
    ...mapActions({
      setCrashBotActive: 'crashSetBotActive',
      addBotGame: 'crashAddBotGame',
      addBotBet: 'crashAddBotBet'
    }),
    handleAutoCashout() {
      // This will be called when multiplier reaches auto cashout in manual mode
      if (
        this.crashMode === "manual" &&
        this.crashGame &&
        this.crashGame.state === "rolling"
      ) {
        this.crashBetCashout();
      }
    },
    crashFormatValue(value) {
      return parseFloat(value).toFixed(2).toString();
    },
    crashSetMode(mode) {
      if (mode === "manual") {
        this.crashAutoStopButton();
      }
      this.crashMode = mode;
    },
    crashValidateInput() {
      if(this.crashAmount === null || this.crashAmount === undefined) {
        this.crashAmount = '';
        return;
      }
      const value = String(this.crashAmount);
      if(value === '') {
        return;
      }
      this.crashAmount = value.replace(',', '.').replace(/[^\d.]/g, '');
      this.crashAmount = this.crashAmount.indexOf('.') >= 0
        ? this.crashAmount.substr(0, this.crashAmount.indexOf('.')) +
          '.' +
          this.crashAmount
            .substr(this.crashAmount.indexOf('.') + 1, 2)
            .replace('.', '')
        : this.crashAmount;
    },
    crashFormatInput() {
      if(this.crashAmount === null || this.crashAmount === '' || this.crashAmount === undefined) {
        this.crashAmount = '';
        return;
      }
      const numValue = parseFloat(this.crashAmount);
      if(isNaN(numValue)) {
        this.crashAmount = '';
        return;
      }
      this.crashAmount = numValue.toFixed(2);
    },
    crashSetInput(value, action) {
      let amount = parseFloat(this[value]) || 0;

      if (action === "min") {
        if (value === "crashAmount") {
          amount = 0.01;
        } else if (value === "crashAutoCashout") {
          amount = 1.01;
        }
      } else if (action === "1/2") {
        if (amount === 0) {
          amount = value === "crashAmount" ? 0.01 : 1.01;
        } else {
          amount = amount / 2;
        }
      } else if (action === "2x") {
        if (amount === 0) {
          amount = value === "crashAmount" ? 0.01 : 1.01;
        } else {
          amount = amount * 2;
        }
      } else if (action === "10x") {
        amount = amount * 10;
      } else if (action === "max") {
        if (value === "crashAmount") {
          const balance = this.authUser.user !== null ? this.authUser.user.balance : 0;
          amount = balance;
        } else if (value === "crashAutoCashout") {
          amount = 1000; // Max multiplier for auto cashout
        }
      } else if (action === "10") {
        amount = 10;
      } else if (action === "100") {
        amount = 100;
      } else if (action === "1000") {
        amount = 1000;
      } else if (action === "10000") {
        amount = 10000;
      }

      // Ensure minimum values
      if (value === "crashAmount" && amount < 0.01 && action !== "min") {
        amount = 0.01;
      } else if (value === "crashAutoCashout" && amount < 1.01 && action !== "min") {
        amount = 1.01;
      }

      // Ensure amount doesn't exceed balance for crashAmount
      if (value === "crashAmount") {
        const balance = this.authUser.user !== null ? this.authUser.user.balance : 0;
        if (amount > balance && balance > 0) {
          amount = balance;
        }
      }

      this[value] = parseFloat(amount).toFixed(2);
    },
    crashAutoStartButton() {
      const percentageWin = Math.floor(this.crashAutoPercentageWin);
      const percentageLoss = Math.floor(this.crashAutoPercentageLoss);

      if (
        isNaN(percentageWin) === true ||
        percentageWin < 0 ||
        percentageWin > 100
      ) {
        this.notificationShow({
          type: "error",
          message: "Your entered auto bet win percentage is invalid.",
        });
        return;
      }

      if (
        isNaN(percentageLoss) === true ||
        percentageLoss < 0 ||
        percentageLoss > 100
      ) {
        this.notificationShow({
          type: "error",
          message: "Your entered auto bet loss percentage is invalid.",
        });
        return;
      }

      if (isNaN(Math.floor(this.crashAutoStopProfit)) === true) {
        this.notificationShow({
          type: "error",
          message: "Your entered auto bet profit stop is invalid.",
        });
        return;
      }

      if (isNaN(Math.floor(this.crashAutoStopLoss)) === true) {
        this.notificationShow({
          type: "error",
          message: "Your entered auto bet loss stop is invalid.",
        });
        return;
      }

      if (isNaN(Math.floor(this.crashAutoBetCount)) === true) {
        this.notificationShow({
          type: "error",
          message: "Your entered auto bet count is invalid.",
        });
        return;
      }

      if (Math.floor(this.crashAutoBetCount) === 0) {
        this.crashAutoInfinite = true;
      }

      this.crashAutoRunning = true;
      // Set bot as active in store
      this.setCrashBotActive(true);
      
      if (this.crashGame.state === "created") {
        this.crashBetButton();
      }
    },
    crashAutoStopButton() {
      this.crashAutoTotalBet = 0;
      this.crashAutoTotalWon = 0;
      this.crashAutoInfinite = false;
      this.crashAutoRunning = false;
      // Set bot as inactive in store
      this.setCrashBotActive(false);
    },
    crashBetButton() {
      if (this.socketSendLoading !== null) {
        return;
      }

      if (!this.authenticated) {
        this.$root.$emit('open-signin-modal-app');
        this.crashAutoStopButton();
        return;
      }

      const amount = parseFloat(Number(this.crashAmount)) || 0;
      const autoCashout =
        this.crashAutoCashout === null || this.crashAutoCashout.trim() === ""
          ? 0
          : Math.round(parseFloat(this.crashAutoCashout) * 100);

      if (isNaN(amount) === true || amount <= 0) {
        this.notificationShow({
          type: "error",
          message: "Your entered bet amount is invalid.",
        });
        this.crashAutoStopButton();
        return;
      }

      if (
        isNaN(autoCashout) === true ||
        ((autoCashout !== 0 || this.crashMode === "auto") && autoCashout <= 100)
      ) {
        this.notificationShow({
          type: "error",
          message: "Your entered bet auto cashout is invalid.",
        });
        this.crashAutoStopButton();
        return;
      }

      const data = { amount: amount, autoCashout: autoCashout };
      this.crashSendBetSocket(data);
      
      // Track bot game if auto mode is active
      if (this.crashAutoRunning && this.crashGame && this.crashGame._id) {
        this.addBotGame(this.crashGame._id);
      }
    },
    crashBetCashout() {
      if (this.socketSendLoading !== null) {
        return;
      }

      if (!this.authenticated) {
        this.notificationShow({
          type: "error",
          message: "Please sign in to perform this action.",
        });
        return;
      }

      if (this.socketCrash === null || this.socketCrash.connected === false) {
        this.notificationShow({
          type: "error",
          message: "Socket connection is not established. Please wait...",
        });
        return;
      }

      if (this.crashGame === null || this.crashGame.state !== "rolling") {
        this.notificationShow({
          type: "error",
          message: "Game is not in rolling state. Cannot cash out.",
        });
        return;
      }

      const userBet = this.crashBets.find(
        (element) =>
          element.user._id === this.authUser.user._id &&
          element.multiplier === undefined
      );
      if (!userBet) {
        this.notificationShow({
          type: "error",
          message: "No active bet found to cash out.",
        });
        return;
      }

      const data = {};
      this.crashSendCashoutSocket(data);
    },
  },
  computed: {
    ...mapGetters([
      "socketSendLoading",
      "authUser",
      "authenticated",
      "crashGame",
      "crashBets",
      "socketCrash",
    ]),
    crashHasActiveBet() {
      if (
        !this.authenticated ||
        !this.crashBets ||
        this.crashBets.length === 0
      ) {
        return false;
      }
      if (this.crashGame === null) {
        return false;
      }
      // Only show cashout button when game is rolling or created (betting phase)
      // Don't show if game is completed
      if (this.crashGame.state === "completed") {
        return false;
      }
      return this.crashBets.some((element) => {
        if (!element || !element.user) {
          return false;
        }
        return (
          element.user._id === this.authUser.user._id &&
          (element.multiplier === undefined || element.multiplier === null)
        );
      });
    },
    crashGetPlayerCount() {
      let players = [];

      for (const bet of this.crashBets) {
        if (players.includes(bet.user._id) === false) {
          players.push(bet.user._id);
        }
      }

      return players.length;
    },
    crashGetBetsAmount() {
      let amount = 0;

      for (const bet of this.crashBets) {
        amount = amount + (bet.amount || 0);
      }

      return amount;
    },
    crashProfitOnWin() {
      const amount = parseFloat(this.crashAmount) || 0;
      const autoCashout = parseFloat(this.crashAutoCashout) || 0;
      const mult = autoCashout > 0 ? autoCashout : 2;
      return amount * (mult - 1);
    },
  },
  watch: {
    crashGame: {
      handler(data, dataOld) {
        if (data.state === "created" && this.crashAutoRunning === true) {
          const profit = Math.floor(
            this.crashAutoTotalWon - this.crashAutoTotalBet
          );

          if (
            (this.crashAutoInfinite === true || this.crashAutoBetCount > 0) &&
            (Math.floor(this.crashAutoStopProfit) === 0 ||
              profit <= 0 ||
              profit < this.crashAutoStopProfit) &&
            (Math.floor(this.crashAutoStopLoss) === 0 ||
              profit >= 0 ||
              Math.abs(profit) < this.crashAutoStopLoss)
          ) {
            this.crashBetButton();
          } else {
            this.crashAutoStopButton();
          }
        }
      },
      deep: true,
    },
    crashBets: {
      deep: true,
      handler(data, dataOld) {
        console.log(data);
        const index = data.findIndex(
          (element) => element.user._id === this.authUser.user._id
        );
        if (index !== -1 && this.crashMode === "auto") {
          const bet = data[index];

          if (bet.payout !== undefined) {
            this.crashAutoTotalWon = this.crashAutoTotalWon + bet.payout;
          } else {
            if (Math.floor(this.crashAutoBetCount) > 0) {
              this.crashAutoBetCount = this.crashAutoBetCount - 1;
            }
            this.crashAutoTotalBet = this.crashAutoTotalBet + bet.amount;
          }
        }
      },
    },
  },
  mounted() {
    // Listen for auto cashout event from CrashGame
    this.$root.$on("crash-auto-cashout", this.handleAutoCashout);
  },
  beforeDestroy() {
    // Clean up event listeners
    this.$root.$off("crash-auto-cashout", this.handleAutoCashout);
  },
};
</script>

<style scoped>
.crash-controls {
  width: 360px;
  height: auto;
  padding: 15px;
  border-radius: 20px;
  background: var(--bg-table-background);
  /* border: 1px solid rgba(255, 255, 255, 0.1);*/
  /* box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.5), inset 0px 1px 0px rgba(255, 255, 255, 0.1);*/
  position: relative;
  overflow: visible;
}


.crash-controls .controls-mode {
  width: 100%;
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  position: relative;
  background: var(--bg-blue-dark);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 100px;
  padding: 2px;
}

.crash-controls .controls-mode .tab-button {
  flex: 1;
  height: 36px;
  position: relative;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1;
}

.crash-controls .controls-mode .tab-button .tab-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  background: transparent;
  border: none;
  border-radius: 100px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
}

.crash-controls .controls-mode .tab-button.tab-active .tab-inner {
  color: #ffffff;
  background: var(--gradient-purple-btn-bg);
  border: none;
}

.crash-controls .controls-mode .tab-button:not(:disabled):hover .tab-inner {
  color: #ffffff;
  background: transparent;
}

.crash-controls .controls-mode .tab-button.tab-active:not(:disabled):hover .tab-inner {
  color: #ffffff;
  background: var(--gradient-purple-btn-bg);
}

.crash-controls .controls-amount {
  width: 100%;
  position: relative;
  margin-top: 20px;
}

.crash-controls .bet-label {
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 8px;
}

.crash-controls .bet-input-container {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  background: var(--bg-blue-dark);
  border-radius: 100px;
  padding: 0 15px;
  gap: 15px;
}

.crash-controls .bet-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.crash-controls .bet-icon-wrapper svg {
  width: 24px;
  height: 24px;
}

.crash-controls .bet-separator {
  width: 1px;
  height: 30px;
  background: rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
}

.crash-controls .bet-value-display {
  flex: 1;
  display: flex;
  align-items: center;
}

.crash-controls .bet-value-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  padding: 0;
  text-align: left;
}

.crash-controls .bet-value-input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.crash-controls .bet-value-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.crash-controls .bet-quick-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.crash-controls .quick-action-btn {
  min-width: 32px;
  height: 28px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.crash-controls .quick-action-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}

.crash-controls .quick-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.crash-controls .quick-action-btn.max-btn {
  border-radius: 6px;
  padding: 0 10px;
}

.crash-controls .bet-preset-buttons {
  width: 100%;
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.crash-controls .preset-btn {
  flex: 1;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-blue-dark);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 47px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.crash-controls .preset-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.2);
}

.crash-controls .preset-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.crash-controls .controls-cashout {
  width: 100%;
  position: relative;
  margin-top: 20px;
}

.crash-controls .controls-cashout input {
  width: 100%;
  height: 50px;
  padding: 0 43px 0 43px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  background: var(--bg-blue-dark);
  border-radius: 100px;
  border: none;
  outline: none;
  position: relative;
}

.crash-controls .controls-cashout input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.crash-controls .controls-cashout input::placeholder {
  color: #5e768e;
}

.crash-controls .controls-manual {
  width: 100%;
  margin-top: 20px;
}

.crash-controls .controls-manual button.button-cashout,
.crash-controls .controls-manual button.button-bet {
  width: 100%;
  height: 44px;
  position: relative;
  z-index: 1;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  margin-top: 25px;
  padding: 0;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
}

.crash-controls .controls-manual button.button-bet:disabled,
.crash-controls .controls-manual button.button-cashout:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.crash-controls .controls-manual button.button-cashout .button-inner,
.crash-controls .controls-manual button.button-bet .button-inner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--gradient-button-bg);
  box-sizing: border-box;
  transition: opacity 0.2s ease;
  position: relative;
  color: #ffffff;
  font-size: 15px;
  font-weight: 800;
}

.crash-controls .controls-manual button.button-bet .button-inner {
  background: var(--gradient-purple-btn-bg);
}

.crash-controls .profit-on-win-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.crash-controls .profit-on-win-row .profit-label {
  font-weight: 600;
}

.crash-controls .profit-on-win-row .profit-value {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: #ffffff;
}

.crash-controls .profit-on-win-row .profit-value svg {
  width: 14px;
  height: 14px;
}

.crash-controls .manual-bets {
  width: 100%;
  margin-top: 18px;
}

.crash-controls .bets-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(24, 72, 109, 0.5);
}

.crash-controls .header-player {
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  color: #ffffff;
}

.crash-controls .header-player svg {
  width: 14px;
  height: 12px;
  margin-right: 8px;
  fill: #ffffff;
}

.crash-controls .header-player svg path {
  fill: #ffffff;
}

.crash-controls .header-player span {
  margin-left: 5px;
  background: linear-gradient(255deg, #ffffff 0%, #cccccc 100%), #ffffff;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
 /* text-fill-color: transparent;*/
}

.crash-controls .header-amount {
  display: flex;
  align-items: center;
}

.crash-controls .header-amount svg {
  width: 12px;
  height: 12px;
  margin-right: 8px;
}

.crash-controls .amount-value {
  font-size: 8px;
  font-weight: 600;
  color: #ffffff;
}

.crash-controls .amount-value span {
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
}

.crash-controls .bets-content {
  width: 100%;
  height: 167px;
  position: relative;
  margin-top: 10px;
}

.crash-controls .bets-content::before {
  content: "";
  width: 100%;
  height: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.crash-controls .content-list {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
}

.crash-controls .content-list::-webkit-scrollbar-track {
  background-color: transparent;
}

.crash-controls .content-list::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.crash-controls .controls-auto {
  width: 100%;
  margin-top: 20px;
}

.crash-controls .auto-adjust,
.crash-controls .auto-stop {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.crash-controls .auto-stop {
  margin-top: 20px;
}

.crash-controls .adjust-win,
.crash-controls .adjust-lose,
.crash-controls .stop-profit,
.crash-controls .stop-lose,
.crash-controls .auto-count {
  width: calc(50% - 3px);
  height: 51px;
  position: relative;
}

.crash-controls .auto-count {
  width: 100%;
  margin-top: 20px;
}

.crash-controls .adjust-win::before,
.crash-controls .adjust-lose::before,
.crash-controls .stop-profit::before,
.crash-controls .stop-lose::before,
.crash-controls .auto-count::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 15px;
}

.crash-controls .adjust-win input,
.crash-controls .adjust-lose input,
.crash-controls .stop-profit input,
.crash-controls .stop-lose input,
.crash-controls .auto-count input {
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  position: absolute;
  top: 1px;
  left: 1px;
  padding: 0 0 0 15px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  background: var(--bg-blue-dark);
  border-radius: 100px;
  border: none;
}

.crash-controls .stop-profit input,
.crash-controls .stop-lose input {
  padding: 0 0 0 26px;
}

.crash-controls .adjust-win input::placeholder,
.crash-controls .adjust-lose input::placeholder,
.crash-controls .stop-profit input::placeholder,
.crash-controls .stop-lose input::placeholder,
.crash-controls .auto-count input::placeholder {
  font-size: 11px;
  color: #888888;
}

.crash-controls .stop-profit svg,
.crash-controls .stop-lose svg {
  width: 11px;
  height: 11px;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translate(0, -50%);
}

.crash-controls .controls-auto button.button-auto,
.crash-controls .controls-auto button.button-stop {
  width: 100%;
  height: 44px;
  position: relative;
  z-index: 1;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  margin-top: 25px;
  padding: 0;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
}

.crash-controls .controls-auto button.button-auto:disabled,
.crash-controls .controls-auto button.button-stop:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.crash-controls .controls-auto button.button-auto .button-inner,
.crash-controls .controls-auto button.button-stop .button-inner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--gradient-button-bg);
  box-sizing: border-box;
  transition: opacity 0.2s ease;
  position: relative;
  color: #ffffff;
  font-size: 15px;
  font-weight: 800;
}

.crash-controls .controls-auto button.button-auto .button-inner {
  background: var(--gradient-purple-btn-bg);
}

.crash-controls .controls-auto button.button-stop .button-inner {
  background: var(--gradient-button-bg);
}

@media only screen and (max-width: 950px) {
  .crash-controls {
    width: 100%;
    height: auto;
    margin-top: 0;
    padding: 12px;
    display: flex;
    flex-direction: column;
  }

  /* Swap: PLACE BET button at top, Manual/Auto below */
  .crash-controls .controls-manual,
  .crash-controls .controls-auto {
    order: 0;
  }

  .crash-controls .controls-mode {
    order: 1;
    margin-bottom: 12px;
  }

  .crash-controls .controls-amount {
    order: 2;
  }

  .crash-controls .controls-cashout {
    order: 3;
  }

  .crash-controls .controls-amount {
    margin-top: 12px;
  }

  .crash-controls .bet-input-container {
    height: 52px;
    min-height: 52px;
  }

  .crash-controls .quick-action-btn {
    min-width: 42px;
    height: 34px;
    font-size: 12px;
  }

  .crash-controls .controls-cashout {
    margin-top: 12px;
  }

  .crash-controls .controls-manual button.button-cashout,
  .crash-controls .controls-manual button.button-bet {
    height: 48px;
    margin-top: 12px;
    min-height: 48px;
  }

  .crash-controls .controls-manual button.button-cashout .button-inner,
  .crash-controls .controls-manual button.button-bet .button-inner {
    font-size: 15px;
  }

  .crash-controls .profit-on-win-row {
    padding: 8px 0;
  }

  .crash-controls .bet-preset-buttons {
    margin-top: 8px;
  }

  .crash-controls .preset-btn {
    height: 40px;
    min-height: 40px;
    font-size: 12px;
  }

  .crash-controls .controls-cashout input {
    height: 44px;
    min-height: 44px;
  }

  .crash-controls .manual-bets {
    display: none;
  }
}

@media only screen and (max-width: 575px) {
}

@media only screen and (max-width: 425px) {
}

@media only screen and (max-width: 350px) {
}
</style>
